import { Icon } from "antd";
import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import i18n from "../../../../../../constants/initLng";
import { formatValidation } from "../../../../../../helpers/functions";
import Image from "../../Image";
import Modal from "../../Modal";
import PreviewButtonImg from "./PreviewButtonImg";

const ItemTypes = {
  ImageDnd: "ImageDnd",
};

const style = {
  cursor: "move"
};

const ImageItem = (props) => {
  const { id, thumb, index, moveImageItem, multiple, thumbnailSize, onSelectFile } = props;
  const ref = useRef(null);

  const onRemoveThumbnail = (thumb, index) => {
    const { removeWithoutConfirm } = props;
    // if (removeWithoutConfirm) {
      return (
        props.onRemoveThumbnail &&
        props.onRemoveThumbnail(thumb, index)
      );
    // }
    // const { confirm } = Modal;
    // confirm({
    //   title: formatValidation(i18n.t("validation.statusCode.code.7"), ""),
    //   okText: i18n.t(`action.remove`),
    //   cancelText: i18n.t(`action.cancel`),
    //   onOk: () => {
    //     props.onRemoveThumbnail &&
    //       props.onRemoveThumbnail(thumb, index);
    //   },
    // });
  };

  const [{ isOver }, drop] = useDrop({
    accept: ItemTypes.ImageDnd,
    canDrop: () => props.allowChangeOrder,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
    drop(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Time to actually perform the action
      moveImageItem(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });
  const [, drag] = useDrag({
    item: { type: ItemTypes.ImageDnd, id, index },
    canDrag: () => props.allowChangeOrder,
  });

  drag(drop(ref));

  const styleDnd = () => {
    if(props.allowChangeOrder){
      return style;
    }

    return {};
  }

  return (
    <div ref={ref} style={{ ...styleDnd() }}>
      <div
        key={index}
        className={`image-thumb-wrapper`}
        style={{
          position: "relative",
          width: thumbnailSize,
          ...(props.thumbnailStyle || {}),
        }}
      >
        <div
          className={`image-thumb`}
          onClick={
            multiple
              ? () =>
                  props.onClickImage &&
                  props.onClickImage(thumb, index)
              : onSelectFile
          }
          style={{ width: thumbnailSize, height: thumbnailSize }}
        >
          <Image
            src={thumb}
            width={`100%`}
            className={`cursorPointer img-thumbnail ml-3`}
            style={{border: isOver ? 'dotted 4px #6c6c6c' : ''}}
          />
        </div>
        <div className="expandImage">
          <PreviewButtonImg
            index={index}
            multiple={props.multiple}
            onClickImage={props.onClickImage}
            onSelectFile={onSelectFile}
            thumbnails={props.thumbnails}
          />

          {props.isPreview3x3 && (
            <PreviewButtonImg
              isPreview3x3
              index={index}
              multiple={props.multiple}
              onClickImage={props.onClickImage}
              onSelectFile={onSelectFile}
              thumbnails={props.thumbnails}
            />
          )}
        </div>
        {!props.disabledRemove && (
          <Icon
            type={"close"}
            className={`cursorPointer removeImage`}
            onClick={(e) => onRemoveThumbnail(thumb, index)}
          />
        )}
      </div>
    </div>
  );
};

export default ImageItem;
